module.exports = __webpack_public_path__ + "img/838.1d487fa4.png";